import React from "react";

export default function BioLinkActionPlatforms({
    platforms = []
}) {

    const activePlatforms = platforms.filter(p => {
        // allow email even without url
        if (p.id === "email_subscribe") return true;
        return p.url;
    });

    if (!activePlatforms.length) return null;

    return (
        <div className="space-y-2">

            {activePlatforms.map((stream) => {

                //EMAIL SUBSCRIBE UI
                if (stream.id === "email_subscribe") {
                    return (
                        <div
                            key={stream.id}
                            className="flex w-full rounded-md overflow-hidden bg-black/40 border border-white/20 backdrop-blur-md"
                        >
                            <input
                                type="email"
                                disabled={true}
                                placeholder="Your Email..."
                                className="flex-1 px-4 py-2 text-xs text-white placeholder-gray-300 bg-transparent outline-none"
                            />

                            <button className="bg-white px-3 text-xs font-semibold text-gray-500 hover:text-black transition">
                                Subscribe
                            </button>
                        </div>
                    );
                }

                // NORMAL PLATFORM
                const baseLink = stream.url || "#";
                const actionText = stream.actionName;

                return (
                    <a
                        key={stream.id}
                        href={baseLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="bg-white flex items-center justify-between rounded-md px-3 py-2"
                    >
                        <span className="font-semibold text-xs text-gray-800">
                            {actionText}
                        </span>

                        <span className="flex items-center gap-2">
                            <span className="font-medium text-xs text-gray-500">
                                {stream.name}
                            </span>

                            <img
                                src={stream.icon}
                                alt={stream.name}
                                className="h-6 w-6"
                            />
                        </span>
                    </a>
                );
            })}

        </div>
    );
}